import { useStats } from '../../lib/ctx/stats'

export const useMomBooksGrid = () => {
  const stats = useStats((s) => s.stats)
  const bookStats = stats?.mom_books_read?.results || []

  const getHighestBookCountInMonth = () => {
    let highestCount = 0

    bookStats.forEach((s) => {
      if (s.count > highestCount) highestCount = s.count
    })

    return highestCount
  }

  const getColumnCount = () => {
    const highestBookCount = getHighestBookCountInMonth()

    if (highestBookCount <= 10) return 10
    if (highestBookCount >= 25) return 25

    return Math.ceil(highestBookCount / 5) * 5
  }

  const highestBookCount = getHighestBookCountInMonth()
  const columnCount = getColumnCount()

  return { columnCount, highestBookCount, bookStats }
}
